module.exports = __webpack_public_path__ + "static/media/recipe_top_banner_en.5d78ca73.png";